// Shared
export const SHARED_BASE_KEY = "shared"
export const WELCOME_BASE_KEY = "welcome"
export const REGISTER_BASE_KEY = "register"
export const RECEIPT_BASE_KEY = "receipt"

export const SESSION_BASE_KEY = "session"
export const SETUP_INTENT_BASE_KEY = "setupIntent"
export const CONFIRM_SETUP_INTENT_BASE_KEY = "confirmSetupIntent"
export const PAYMENT_INTENT_BASE_KEY = "paymentIntent"
export const CONFIRM_PAYMENT_BASE_KEY = "confirmPayment"
export const GET_CONFIRMATION_DETAILS_BASE_KEY = "getConfirmationDetails"
export const CHECKOUT_BASE_KEY = "checkout"
export const SESSION_DETAILS_BASE_KEY = "sessionDetails"

export const ME_BASE_KEY = "mua"
export const SAVED_PAYMENT_METHODS_BASE_KEY = "savedPaymentMethods"
export const SAVED_PAYMENT_METHODS_WALLET_INTENT =
  "savedPaymentMethodWalletIntent"
